import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";

// Component
import Toast from "../../../../components/WMS/Toast";

// Assets
import RedWarning from "assets/img/redWarning.svg"

//Utils
import {UserAgentUtils} from "utils/useragent";

WrongShipmentToast.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.string
};

function WrongShipmentToast({isOpen, handleClose, title, subtitle = null, ...props}) {
    const icon = (
        <img
            src={RedWarning}
            alt={title}
            style={{width: '20px', height: '20px'}}
        />
    );

    return (
        <Toast
            open={isOpen}
            handleClose={handleClose}
            title={title}
            subtitle={subtitle}
            isTop={!UserAgentUtils.isMobile()}
            isDesktop={!UserAgentUtils.isMobile()}
            icon={icon}
        />
    );
}

export default injectIntl(WrongShipmentToast);
